/* eslint-disable no-else-return */
import React, { FC, useState } from 'react';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import useSessionChecking from '../../hooks/useSessionChecking';
import { BackMappings } from '../../utils/BackMappings';
import { GtmConstants } from '../../utils/GtmConstants';
import { StorageHelper } from '../../utils/StorageHelper';
import { SystemManager } from '../../utils/SystemManager';

const PuntosTravel: FC = () => {
  StorageHelper.setOrigin(BackMappings.PUNTOS_TRAVEL);
  const [goOn, setGoOn] = useState<boolean>(false);
  useSessionChecking(BackMappings.PUNTOS_TRAVEL, setGoOn, goOn);
  useDatalayerEvents(GtmConstants.MIS_VENTAJAS);

  if (goOn) {
    return <>{SystemManager.getSystem('puntos-travel')}</>;
  }
  return <></>;
};

export default PuntosTravel;
